import {cardTitle, primaryColor, secondaryColor, tertiaryColor, title} from "../../../nextjs-material-kit.js";
import imagesStyle from "../../../nextjs-material-kit/imagesStyles.js";
import { container } from "../../../nextjs-material-kit.js";

const pageDetailStyle = (theme) => ({
  cardTitle: {
    ...cardTitle,
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    textAlign: "left",
    color: "#095A70",
    fontSize: "40px",
    paddingLeft: "0",
    lineHeight: 1,
  },
});

export default pageDetailStyle;
